export default "__VITE_PUBLIC_ASSET__ed1ba638__"